"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useStyle = ({ selected, blackThemeStyle, insideTipV2 = false, shouldStretchBoxes = false }) => {
    const theme = (0, material_1.useTheme)();
    const container = Object.assign({ position: 'relative', fontWeight: '400', padding: '4px 8px', fontSize: '0.75rem', borderRadius: '6px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', height: '56px' }, (!insideTipV2 && Object.assign({ minWidth: 'max-content', width: shouldStretchBoxes ? '100% !important' : 'max-content !important', color: theme.qlub.palette.onColorColors.mediumEmphasis, border: 'solid 1px rgba(230, 230, 230, 1)', background: 'rgba(255, 255, 255, 1)' }, (selected && {
        '> div ': {
            color: blackThemeStyle ? theme.qlub.palette.black.main : theme.palette.primary.main,
        },
        background: blackThemeStyle ? 'rgba(0, 0, 0, 0.08)' : theme.palette.secondary.main,
        borderColor: blackThemeStyle ? theme.qlub.palette.black.main : theme.palette.primary.main,
    }))));
    const contents = Object.assign(Object.assign({ flex: '1 1', fontWeight: 'normal', color: theme.qlub.palette.black.main, display: 'flex', alignItems: 'center', justifyContent: 'center' }, (selected && {
        color: blackThemeStyle ? theme.qlub.palette.black.main : theme.palette.primary.main,
    })), { ' > span': {
            display: 'flex',
            alignItems: 'center',
        }, svg: {
            height: '18px',
        } });
    const closeIcon = {
        position: 'absolute',
        top: '-6px',
        '&.MuiSvgIcon-root': {
            width: '16px',
            height: '16px',
        },
        'html[dir="ltr"] &': {
            right: '-5px',
        },
        'html[dir="rtl"] &': {
            left: '-5px',
        },
        color: theme.palette.primary.main,
    };
    return {
        container,
        contents,
        closeIcon,
    };
};
exports.default = useStyle;
